<template>
  <div>
    <el-row>
      <p :style="{ textAlign: 'center', fontSize: '16px' }">园区人员出入趋势</p>
      <v-chart
        :style="{ height: '300px', width: '400px', marginLeft: '30px' }"
        :options="OutInData"
        :auto-resize="true"
        theme="macarons"
      ></v-chart>
    </el-row>
  </div>
</template>

<script>
// 导入主题，引用时在v-chart中增加theme="macarons"
import "echarts/theme/macarons";
import { getOneTrendChart, getTwoTrendChart } from '@/api/business/beijing/door'
export default {
  data() {
    return {
      OutInData: {},
      OldData: {},
      deviceList: [
        {
          deviceName: '一楼门禁',
          deviceLocationX: 400,
          deviceLocationY: 200
        },
        {
          deviceName: '图书馆门禁',
          deviceLocationX: 600,
          deviceLocationY: 100
        },
        {
          deviceName: '实验室门禁',
          deviceLocationX: 900,
          deviceLocationY: 20
        },

      ]
    };

  },
  created() {
    this.getOldData()
    const res = {
      data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    }
    this.getOutInData(res)
    console.log(+this.$route.query.projectType)
    const params = {
      local: this.$route.query.local
    }

    if (+(this.$route.query.projectType) === 1) {

      getOneTrendChart(params).then(res => {
        this.getOutInData(res)
      })
    } else {
      getTwoTrendChart(params).then(res => {
        this.getOutInData(res)
      })
    }


  },
  methods: {
    getOutInData(res) {
      let option = {
        tooltip: {
          trigger: 'axis'       //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据
        },
        legend: {
          // data: ['进', '出'],
          // x: 'left',
        },
        toolbox: {          //工具栏
          show: false,
          feature: {
            mark: { show: true },   //辅助线标志
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },   //动态类型切换
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        calculable: true,    //是否启用拖拽重计算特性，默认关闭
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,     //控制x轴的数值是否顶头，默认为true留空，false则顶头
            data: ["00", "02", "04", "06", "08", "10", "12", "14", "16", "18", "20", "22"]
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'      //formatter: '{value} °C',//轴上的数据带单位
            }
          }
        ],
        series: [
          {
            type: 'line',    
            data: res.data,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' }
              ]
             
            }
          },
          // {
          //   name: '出',
          //   type: 'line',    
          //   data: res.data.out,
          //   markPoint: {
          //     data: [
          //       { type: 'max', name: '最大值' },
          //       { type: 'min', name: '最小值' }
          //     ]
          //   }
          // }
        ]
      }
      this.OutInData = option
    },
    getOldData() {
      let childCount = 20;
      let juvenileCount = 50;
      let youthCount = 50;
      let middleCount = 35;
      let elderlyCount = 12;
      let totalCount = childCount + juvenileCount + youthCount + middleCount + elderlyCount;
      let childCountPercent = "0.00%";
      let juvenileCountPercent = "0.00%";
      let youthCountPercent = "0.00%";
      let middleCountPercent = "0.00%";
      let elderlyCountPercent = "0.00%";
      if (totalCount != 0) {
        childCountPercent = (childCount / totalCount * 100).toFixed(2) + "%";
        juvenileCountPercent = (juvenileCount / totalCount * 100).toFixed(2) + "%";
        youthCountPercent = (youthCount / totalCount * 100).toFixed(2) + "%";
        middleCountPercent = (middleCount / totalCount * 100).toFixed(2) + "%";
        elderlyCountPercent = (elderlyCount / totalCount * 100).toFixed(2) + "%";
      }
      let option = {
        tooltip: {
          trigger: 'item',
        },
        grid: {   //直角坐标系中除坐标轴外的绘图网格，用于定义直角系整体布局
          top: '4%',
          left: '0%',
          right: '0%',
          bottom: '1%',
          containLabel: true
        },
        legend: {
          orient: 'vertical',    //布局方式：默认 horizontal 水平/   vertical 垂直
          top: 'middle',
          right: 5,
          itemWidth: 16,
          itemHeight: 1,
          // itemGap:15,
          data: [
            { name: '0~12岁(儿童)  ' + childCountPercent, icon: 'pin' },
            { name: '13~18岁(少年)  ' + juvenileCountPercent, icon: 'pin' },
            { name: '18~39岁(青年)  ' + youthCountPercent, icon: 'pin' },
            { name: '40~60岁(中年)  ' + middleCountPercent, icon: 'pin' },
            { name: '61岁以上(老年)  ' + elderlyCountPercent, icon: 'pin' },
          ]
        },
        color: ['#4ab3d1', "#d9804c", "#eba538", "#87aa66", '#3cb371'],
        series: [
          {
            name: '各年龄段占比',
            type: 'pie',
            radius: ['65%', '80%'],
            center: ['30%', '50%'],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '16',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: childCount, name: '0~12岁(儿童)  ' + childCountPercent },
              { value: juvenileCount, name: '13~18岁(少年)  ' + juvenileCountPercent },
              { value: youthCount, name: '18~39岁(青年)  ' + youthCountPercent },
              { value: middleCount, name: '40~60岁(中年)  ' + middleCountPercent },
              { value: elderlyCount, name: '61岁以上(老年)  ' + elderlyCountPercent },
            ]
          }
        ]
      }
      this.OldData = option
    }

  }
}
</script>

<style>
</style>